import { FaPhoneAlt, FaWhatsapp } from 'react-icons/fa'
// import Arrow from "../../assets/images/arrow.svg"; // Unused import
import BannerImage from '../../assets/images/landing2.webp'
import Booking from '../Booking/Booking'
import Button from '../Button/Button'
import style from './Banner.module.scss'

const generateWhatsappLink = () => {
  // eg. https://api.whatsapp.com/send?phone=447943152288&text=I%20would%20like%20to%20book%20a%20ride
  const phoneNumber = '+447943152288'
  const message = 'I would like to book a ride'
  return `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`
}

const Banner = () => {
  const scrollToBooking = () => {
    const booking = document.getElementById('booking')
    if (booking) {
      booking.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }

  return (
    <section className={style.banner}>
      <img className={style.banner__image} src={BannerImage} alt="Banner" />

      <div className={style.content}>
        <div className={style.content__left}>
          <h1>London’s Premier Chauffeur Experience</h1>
          {/* <Button
            label="Book Now"
            onClick={scrollToBooking}
            extraClass={style.banner__button}
            buttonType="secondary"
          /> */}
          <h3>
            From airport transfers to corporate travel and exclusive events, we ensure every journey
            is seamless and first-class
          </h3>

          <div className={style.banner__contact}>
            <h2>Get in touch with us</h2>

            <div className={style.banner__phoneNumbers}>
              {/* Phone number */}
              <div className={style.banner__phoneNumber}>
                <FaPhoneAlt size={20} />
                <a href="tel:+447943152288">+447943152288</a>
              </div>

              <div className={style.banner__phoneNumber}>
                <FaWhatsapp size={24} />
                <a
                  className={style.banner__whatsappLinkButton}
                  href={generateWhatsappLink()}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Chat with us
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className={style.content__right}>
          <Booking />
        </div>
      </div>
    </section>
  )
}
export default Banner
